import { dataIdFromObject } from 'graphql/apolloClient'
import { DataProxy } from 'apollo-cache'
import {
  ArtboardDetailInfoFragment,
  ArtboardDetailInfoFragmentDoc,
} from 'gqlTypes'

interface ReadArtboardFromCache {
  cache: DataProxy
  id: string
  permanentArtboardShortId: string
  documentVersionShortId: string
}

export const readArtboardFromCache = ({
  cache,
  id,
  permanentArtboardShortId,
  documentVersionShortId,
}: ReadArtboardFromCache) =>
  cache.readFragment<ArtboardDetailInfoFragment>({
    id: dataIdFromObject({
      __typename: 'Artboard',
      shortId: id,
      permanentArtboardShortId,
      documentVersionShortId,
    }) as string,
    fragment: ArtboardDetailInfoFragmentDoc,
    fragmentName: 'ArtboardDetailInfo',
  })

interface WriteArtboardToCache {
  cache: DataProxy
  artboard: ArtboardDetailInfoFragment
}

export const writeArtboardToCache = ({
  cache,
  artboard,
}: WriteArtboardToCache) =>
  cache.writeFragment<ArtboardDetailInfoFragment>({
    id: dataIdFromObject(artboard) as string,
    fragment: ArtboardDetailInfoFragmentDoc,
    fragmentName: 'ArtboardDetailInfo',
    data: artboard,
  })
